/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";

interface Signature {
  Args: {
    Dropdown?: unknown;
    form: unknown;
  };
}

export default class ConsultationReportFormContentPpsSectionsComponent extends Component<Signature> {
  ppsSections = {
    observance: [
      "treatment-taken",
      "bio-exams-done",
      "medicines-reconciliation",
      "therapeutic-education"
    ],
    "physical-health": [
      "gynecologist-consultation",
      "doctor-consultation",
      "diabetologist-consultation",
      "cardiologist-consultation",
      "nephrologist-consultation",
      "neurologist-consultation",
      "weight-measured",
      "blood-pressure-measured"
    ],
    "psychiatric-health": [
      "psychiatrist-consultation",
      "addictologist-consultation",
      "psychologist-consultation",
      "group-psychotherapy",
      "simple-digital-care",
      "happy-neuron-digital-care",
      "crisis-plan-follow-up"
    ],
    "life-hygiene": ["sleep", "physicalActivity", "food", "drugs", "stress"],
    "socio-professional": ["jobCoach", "socialAssistant"]
  };
}
